import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'evaluationAverages'

const list = (axios: IFactoryFunctionRequest<any[], undefined>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
  })
}

const ratingOptions = (axios: IFactoryFunctionRequest<any[], undefined>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/rating-options`,
  })
}

const getOne = (axios: IFactoryFunctionRequest<any, undefined>) => ({ averageId }: { averageId: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${averageId}`,
  })
}

const create = (axios: IFactoryFunctionRequest<any, any>) => (data: { display: string; averageIds: { calcId: string; display: string }[] }) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<any, any>) => ({ averageId, data }: { averageId: string; data: { display: string; averageIds: { calcId: string; display: string }[] } }) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${averageId}`,
    data,
  })
}

const deleteOne = (axios: IFactoryFunctionRequest<void, undefined>) => ({ averageId }: { averageId: string }) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${averageId}`,
  })
}

export default (axios: AxiosInstance) => ({
  list: list(useAxios(axios)),
  ratingOptions: ratingOptions(useAxios(axios)),
  getOne: getOne(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  deleteOne: deleteOne(useAxios(axios)),
})